module.exports = __webpack_public_path__ + "img/pause.20efc25d.svg";